export const getCurrentType = type => {
  if (type === 'favorites') {
    return null
  }

  if (['topics', 'musicTopics'].includes(type)) {
    return ['topic']
  }
  if (['subtopics', 'musicSubtopics'].includes(type)) {
    return ['subtopic']
  }

  const defaultTypes = ['topic', 'subtopic']

  return defaultTypes
}
